import { complaintSend, complaintToggle } from 'mk2/containers/Complaint/Complaint.actions';
import { generateFormName } from 'mk2/containers/Complaint/Complaint.helpers';
import { complaintReducer, ComplaintsState } from 'mk2/containers/Complaint/Complaint.reducers';
import saga from 'mk2/containers/Complaint/Complaint.sagas';
import { ComplaintTargetType } from 'mk2/containers/Complaint/Complaint.schemas';
import { ComplaintFormData, ComplaintFormFactory } from 'mk2/containers/Complaint/ComplaintForm';
import { getComplaintsState, getComplaintShownForTarget } from 'mk2/containers/Complaints/Complaints.selectors';
import registerInStore from 'mk2/decorators/registerInStore';
import { cachedInitialValues } from 'mk2/helpers/form';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { AppState } from 'mk2/reducers';
import React from 'react';
import { connect } from 'react-redux';

interface OwnProps {
    className?: string;
    entity: ComplaintTargetType;
    id: number;
    inForum: boolean;
    inGroups: boolean;
    scrollOffset?: number; // When complaint is displayed we are scrolling him into view - this can be used to add some offset
    hint?: React.ReactNode;
    title?: string;
}

interface StateProps {
    initialValues: ComplaintFormData;
    show: boolean;
}

interface DispatchProps {
    onSend(entity: string, id: number, complaint: ComplaintFormData);
    onCancel(entity: string, id: number);
}

type Props = OwnProps & StateProps & DispatchProps;

/**
 * Split form vs container - inject form to the page only if 'show' is true or it will re-render with every state change
 */
class Complaint extends React.Component<Props> {
    private ComplaintForm = ComplaintFormFactory(generateFormName(this.props.entity, this.props.id));

    public render() {
        const {
            show, className, entity, id, initialValues, inForum, inGroups, scrollOffset, onSend, onCancel, hint,
            title,
        } = this.props;
        const ComplaintForm = this.ComplaintForm;

        return show ? (
            <ComplaintForm
                className={className}
                entity={entity}
                id={id}
                initialValues={initialValues}
                inForum={inForum}
                inGroups={inGroups}
                scrollOffset={scrollOffset}
                onSend={onSend}
                onCancel={onCancel}
                hint={hint}
                title={title}
            />
        ) : null;
    }
}

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    const complaitsState: ComplaintsState = getComplaintsState(state);

    return {
        show: getComplaintShownForTarget(complaitsState, ownProps.entity, ownProps.id),
        initialValues: cachedInitialValues(
            generateFormName(ownProps.entity, ownProps.id),
            {
                comment: '',
            },
            ownProps.id,
        ),
    };
}

const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {
    onSend: complaintSend,
    onCancel: (entity, id) => complaintToggle(entity, id, false),
};

export default registerInStore<OwnProps>((store) => {
    store.injectReducer('containers.global.complaint', complaintReducer);
    store.injectSaga('containers.global.complaint', saga);
})(connect(mapStateToProps, mapDispatchToProps)(Complaint));
